import React, { useState } from 'react';
import { Upload, Trash2, Loader2, ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '@/App';

/* Survey Builder → Thank You Settings → optional static image (upload / replace / remove). */
export default function ThankYouStaticImage({ image, onChange }) {
  const [busy, setBusy] = useState(false);
  const url = image?.url || '';

  const upload = async (file) => {
    if (!file) return;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { toast.error('Only JPG, PNG or WEBP images'); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5MB'); return; }
    setBusy(true);
    try {
      const form = new FormData(); form.append('file', file);
      const r = await fetch(`${API}/surveys/builder/upload-image`, { method: 'POST', credentials: 'include', body: form });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { toast.error(d.detail || 'Upload failed'); return; }
      onChange({ url: d.image_url });
      toast.success(url ? 'Image replaced' : 'Image uploaded');
    } catch { toast.error('Upload failed'); } finally { setBusy(false); }
  };

  return (
    <div className="border-t border-[#E2E8F0] pt-3 space-y-2" data-testid="thankyou-static-image">
      <h4 className="text-xs font-bold text-[#64748B] uppercase">Static Image</h4>
      <p className="text-[10px] text-[#94A3B8]">Optional. Shown below the Thank You message. Not clickable.</p>
      {url ? (
        <img src={url} alt="" className="block w-full h-auto max-h-48 object-contain rounded-lg border border-[#E2E8F0] bg-[#F8FAFC]" data-testid="thankyou-image-preview" />
      ) : (
        <div className="h-20 rounded-lg border-2 border-dashed border-[#CBD5E1] flex items-center justify-center gap-1.5 text-[11px] text-[#94A3B8]" data-testid="thankyou-image-empty">
          <ImageIcon className="w-4 h-4" /> No image
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <label className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border text-[11px] font-semibold cursor-pointer hover:bg-[#F8FAFC] border-[#CBD5E1] text-[#1A3E6F] ${busy ? 'opacity-60 pointer-events-none' : ''}`} data-testid={url ? 'thankyou-image-replace' : 'thankyou-image-upload'}>
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />}
          {url ? 'Replace image' : 'Upload image'}
          <input type="file" className="hidden" accept="image/jpeg,image/png,image/webp"
            onChange={(e) => { upload((e.target.files || [])[0]); e.target.value = ''; }} data-testid="thankyou-image-input" />
        </label>
        {url && (
          <button type="button" onClick={() => onChange(null)} disabled={busy}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-rose-200 text-[11px] font-semibold text-rose-600 hover:bg-rose-50" data-testid="thankyou-image-remove">
            <Trash2 className="w-3 h-3" /> Remove image
          </button>
        )}
      </div>
    </div>
  );
}
